"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOLUTION_COLORS = exports.colorsValues = exports.widgetHighlightColorPalette = exports.matchingBaseColorMap = exports.matchingDWColorWithWashedColorMap = exports.matchingDarkerColorMap = exports.darkColors = exports.matchingDeepWashedColorMap = exports.matchingWashedColorMap = exports.calendarColors = exports.spotLightColors = exports.colorsSelectFontsMap = exports.colorsFontsMap = exports.defaultSolutionColor = exports.solutionColors = exports.defaultEventColor = exports.LandingPageColors = exports.SolutionColors = exports.PlanColors = exports.deepWashedColors = exports.washedColors = exports.baseColors = exports.darkerColors = exports.Colors = exports.GrayColors = exports.SolutionColorVariables = exports.IconColorNames = exports.TextColorNames = void 0;
exports.TextColorNames = {
    white: "#fff",
    primary: "#2E3538",
    secondary: "#878B92",
    tertiary: "#6B6B6B",
};
exports.IconColorNames = {
    light: "#C7CDCF",
    dark: "#2E3538",
    darker: "#151515",
};
exports.SolutionColorVariables = {
    sc1: "var(--solution-primary-color)",
    sc2: "var(--solution-secondary-color)",
    sc3: "var(--solution-hover-color)",
    sc4: "var(--solution-highlight-color)",
};
exports.GrayColors = {
    "G-0": "#FFFFFF",
    "G-0-5": "#FAFAFA",
    "G-1": "#F3F3F4",
    "G-1-2": "#F0F0F0",
    "G-1-5": "#E9E9E9",
    "G-2": "#DEDEDE",
    "G-3": "#C7C8C9",
    "G-4": "#B2B2B3",
    "G-5": "#9B9C9E",
    "G-6": "#868788",
    "G-7": "#6F7173",
    "G-8": "#4d4d4d",
    "G-9": "#232B36",
};
exports.Colors = {
    // === Darker === //
    dBlue: "#0C41F3",
    dLightBlue: "#00B3FA",
    dGreen: "#199A27",
    dRed: "#F1273F",
    dOrange: "#FF702E",
    dYellow: "#FDA80D",
    dPurple: "#673DB6",
    dPink: "#CD286A",
    dTeal: "#00B2A8",
    dGrey: "#2D2D2D",
    // === Base === //
    bBlue: "#3A86FF",
    bLightBlue: "#4ECCFD",
    bGreen: "#3EAC40",
    bRed: "#FF5757",
    bOrange: "#FF9210",
    bYellow: "#FFB938",
    bPurple: "#883CD0",
    bPink: "#EC506E",
    bTeal: "#17C4C4",
    bGrey: "#6A849B",
    // === Enterprise Darker === //
    epdBlue: "#446EB3",
    epdLightBlue: "#5796A9",
    epdGreen: "#4A7D4C",
    epdRed: "#B34A4A",
    epdOrange: "#C07531",
    epdYellow: "#BE9233",
    epdPurple: "#6B4F91",
    epdPink: "#B3596A",
    epdTeal: "#268787",
    epdGrey: "#4C5C6E",
    // === Enterprise Base === //
    epbBlue: "#558AE0",
    epbLightBlue: "#6DBBD3",
    epbGreen: "#5D9C5F",
    epbRed: "#E05C5C",
    epbOrange: "#F0923D",
    epbYellow: "#EDB740",
    epbPurple: "#8663B5",
    epbPink: "#E06F84",
    epbTeal: "#2FA9A9",
    epbGrey: "#5F7389",
    // === Washed === //
    wBlue: "#B7E3FB",
    wLightBlue: "#B3EFFE",
    wGreen: "#CDEECE",
    wRed: "#FEBDC7",
    wOrange: "#FFD5B3",
    wYellow: "#FFECB3",
    wPurple: "#DFCCFF",
    wPink: "#FFC7E7",
    wTeal: "#C2F0ED",
    wGrey: "#D7D7DB",
    // === Enterprise Washed === //
    epwBlue: "#C4D6F4",
    epwLightBlue: "#CCE7F0",
    epwGreen: "#C7DDC7",
    epwRed: "#F4C6C6",
    epwOrange: "#FAD9BB",
    epwYellow: "#F9E6BC",
    epwPurple: "#D5C9E5",
    epwPink: "#F4CDD4",
    epwTeal: "#B6E1E1",
    epwGrey: "#C7CED6",
    // === Deep Washed === //
    dwBlue: "#E7F0FE",
    dwLightBlue: "#E5F8FF",
    dwGreen: "#EEF6EE",
    dwRed: "#FEECEE",
    dwOrange: "#FFEDE5",
    dwYellow: "#FFF2DC",
    dwPurple: "#F2EAFA",
    dwPink: "#FBEAF1",
    dwTeal: "#EBF4F4",
    dwGrey: "#F1F2F3",
    // === Enterprise Deep Washed === //
    epdwBlue: "#EEF3FC",
    epdwLightBlue: "#F0F8FB",
    epdwGreen: "#EFF5EF",
    epdwRed: "#FCEFEF",
    epdwOrange: "#FEF4EC",
    epdwYellow: "#FDF8EC",
    epdwPurple: "#F3EFF8",
    epdwPink: "#FCF1F3",
    epdwTeal: "#EAF6F6",
    epdwGrey: "#EFF1F3",
    // === Custom === //
    custom1: "#FFFFFF",
    custom2: "#000000",
    custom3: "#F3F3F4",
    custom4: "#EFA00B",
    custom5: "#88bbd7",
    custom6: "#b2b2b3",
    custom7: "#fd7038",
    custom8: "#6F7173",
    custom9: "#20C933",
    custom10: "#DD1C1A",
    custom11: "#FDB402",
    custom12: "#A15DDC",
    custom13: "#FF09C3",
    custom14: "#20DAD2",
    custom15: "#2E3538",
    custom16: "#C7C8C9",
    custom17: "#FAFAFA",
    custom18: "#FFDB5C",
    linkedRecordFieldColor: "#E5F8FF",
    linkedRecordFieldHoverColor: "#E5F8FF",
    bulkActionMenuCloseColor: "#8391A6",
};
exports.darkerColors = [
    exports.Colors.dBlue,
    exports.Colors.dLightBlue,
    exports.Colors.dGreen,
    exports.Colors.dRed,
    exports.Colors.dOrange,
    exports.Colors.dYellow,
    exports.Colors.dPurple,
    exports.Colors.dPink,
    exports.Colors.dTeal,
    exports.Colors.dGrey,
    // Enterprise (base colors used as dark colors)
    exports.Colors.epbBlue,
    exports.Colors.epbLightBlue,
    exports.Colors.epbGreen,
    exports.Colors.epbRed,
    exports.Colors.epbOrange,
    exports.Colors.epbYellow,
    exports.Colors.epbPurple,
    exports.Colors.epbPink,
    exports.Colors.epbTeal,
    exports.Colors.epbGrey,
];
exports.baseColors = [
    exports.Colors.bBlue,
    exports.Colors.bLightBlue,
    exports.Colors.bGreen,
    exports.Colors.bRed,
    exports.Colors.bOrange,
    exports.Colors.bYellow,
    exports.Colors.bPurple,
    exports.Colors.bPink,
    exports.Colors.bTeal,
    exports.Colors.bGrey,
    // Enterprise
    exports.Colors.epbBlue,
    exports.Colors.epbLightBlue,
    exports.Colors.epbGreen,
    exports.Colors.epbRed,
    exports.Colors.epbOrange,
    exports.Colors.epbYellow,
    exports.Colors.epbPurple,
    exports.Colors.epbPink,
    exports.Colors.epbTeal,
    exports.Colors.epbGrey,
];
exports.washedColors = [
    exports.Colors.wBlue,
    exports.Colors.wLightBlue,
    exports.Colors.wGreen,
    exports.Colors.wRed,
    exports.Colors.wOrange,
    exports.Colors.wYellow,
    exports.Colors.wPurple,
    exports.Colors.wPink,
    exports.Colors.wTeal,
    exports.Colors.wGrey,
    // Enterprise
    exports.Colors.epwBlue,
    exports.Colors.epwLightBlue,
    exports.Colors.epwGreen,
    exports.Colors.epwRed,
    exports.Colors.epwOrange,
    exports.Colors.epwYellow,
    exports.Colors.epwPurple,
    exports.Colors.epwPink,
    exports.Colors.epwTeal,
    exports.Colors.epwGrey,
];
exports.deepWashedColors = [
    exports.Colors.dwBlue,
    exports.Colors.dwLightBlue,
    exports.Colors.dwGreen,
    exports.Colors.dwRed,
    exports.Colors.dwOrange,
    exports.Colors.dwYellow,
    exports.Colors.dwPurple,
    exports.Colors.dwPink,
    exports.Colors.dwTeal,
    exports.Colors.dwGrey,
    // Enterprise
    exports.Colors.epdwBlue,
    exports.Colors.epdwLightBlue,
    exports.Colors.epdwGreen,
    exports.Colors.epdwRed,
    exports.Colors.epdwOrange,
    exports.Colors.epdwYellow,
    exports.Colors.epdwPurple,
    exports.Colors.epdwPink,
    exports.Colors.epdwTeal,
    exports.Colors.epdwGrey,
];
exports.PlanColors = {
    // === Primary Base === //
    basePrimaryDarkBlue: "#0055DB",
    basePrimaryBlue: "#3A86FF",
    basePrimaryOrange: "#FF9210",
    basePrimaryGreen: "#2b782D",
    // === Secondary Base === //
    baseSecondaryDarkBlue: "#008bc2",
    baseSecondaryBlue: "#6BB0FF",
    baseSecondaryOrange: "#FFBC80",
    baseSecondaryGreen: "#3EAC40",
};
exports.SolutionColors = {
    // === Primary Darker === //
    darkPrimaryBlue: "#0C41F3",
    darkPrimaryLightBlue: "#00B3FA",
    darkPrimaryGreen: "#199A27",
    darkPrimaryRed: "#F1273F",
    darkPrimaryOrange: "#FF702E",
    darkPrimaryYellow: "#FDA80D",
    darkPrimaryPurple: "#673DB6",
    darkPrimaryPink: "#CD286A",
    darkPrimaryTeal: "#00B2A8",
    darkPrimaryGrey: "#50515B",
    // === Secondary Darker === //
    darkSecondaryBlue: "#E7F0FE",
    darkSecondaryLightBlue: "#E7F7FE",
    darkSecondaryGreen: "#EEF6EF",
    darkSecondaryRed: "#FEECEE",
    darkSecondaryOrange: "#FFEDE5",
    darkSecondaryYellow: "#FFF2DB",
    darkSecondaryPurple: "#F2EAFA",
    darkSecondaryPink: "#FAEAF1",
    darkSecondaryTeal: "#EBF4F4",
    darkSecondaryGrey: "#F1F2F3",
    // === Hover Darker === //
    darkHoverBlue: "#0931B9",
    darkHoverLightBlue: "#008BC2",
    darkHoverGreen: "#10651A",
    darkHoverRed: "#BB0C20",
    darkHoverOrange: "#F04B00",
    darkHoverYellow: "#FA7900",
    darkHoverPurple: "#4E2E8A",
    darkHoverPink: "#9A1E4F",
    darkHoverTeal: "#00756F",
    darkHoverGrey: "#34353C",
    // === Highlight Darker === //
    darkHighlightBlue: "#0931B9",
    darkHighlightLightBlue: "#008BC2",
    darkHighlightGreen: "#10651A",
    darkHighlightRed: "#BB0C20",
    darkHighlightOrange: "#F04B00",
    darkHighlightYellow: "#FA7900",
    darkHighlightPurple: "#4E2E8A",
    darkHighlightPink: "#9A1E4F",
    darkHighlightTeal: "#00756F",
    darkHighlightGrey: "#34353C",
    // === Primary Base === //
    basePrimaryBlue: "#3A86FF",
    basePrimaryLightBlue: "#4ECCFD",
    basePrimaryGreen: "#3EAC40",
    basePrimaryRed: "#FF5757",
    basePrimaryOrange: "#FF9210",
    basePrimaryYellow: "#FFB938",
    basePrimaryPurple: "#883CD0",
    basePrimaryPink: "#EC506E",
    basePrimaryTeal: "#17C4C4",
    basePrimaryGrey: "#6A849B",
    // === Secondary Base === //
    baseSecondaryBlue: "#E7F0FE",
    baseSecondaryLightBlue: "#E5F8FF",
    baseSecondaryGreen: "#EEF6EE",
    baseSecondaryRed: "#FEECEE",
    baseSecondaryOrange: "#FFEDE5",
    baseSecondaryYellow: "#FFF2DC",
    baseSecondaryPurple: "#F2EAFA",
    baseSecondaryPink: "#FBEAF1",
    baseSecondaryTeal: "#EAF5F5",
    baseSecondaryGrey: "#F1F2F3",
    // === Hover Base === //
    baseHoverBlue: "#0055dB",
    baseHoverLightBlue: "#02AEF2",
    baseHoverGreen: "#2B782D",
    baseHoverRed: "#E50000",
    baseHoverOrange: "#FA7500",
    baseHoverYellow: "#FF9500",
    baseHoverPurple: "#6a29a8",
    baseHoverPink: "#DD183E",
    baseHoverTeal: "#129797",
    baseHoverGrey: "#4A5D6E",
    // === Highlight Base === //
    baseHighlightBlue: "#0055db",
    baseHighlightLightBlue: "#02aef2",
    baseHighlightGreen: "#2b782d",
    baseHighlightRed: "#e50000",
    baseHighlightOrange: "#FA7500",
    baseHighlightYellow: "#ff9500",
    baseHighlightPurple: "#6a29a8",
    baseHighlightPink: "#dd183e",
    baseHighlightTeal: "#129797",
    baseHighlightGrey: "#4a5d6e",
    // === Enterprise Primary (SC1) === //
    epPrimaryBlue: exports.Colors.epbBlue,
    epPrimaryLightBlue: exports.Colors.epbLightBlue,
    epPrimaryGreen: exports.Colors.epbGreen,
    epPrimaryRed: exports.Colors.epbRed,
    epPrimaryOrange: exports.Colors.epbOrange,
    epPrimaryYellow: exports.Colors.epbYellow,
    epPrimaryPurple: exports.Colors.epbPurple,
    epPrimaryPink: exports.Colors.epbPink,
    epPrimaryTeal: exports.Colors.epbTeal,
    epPrimaryGrey: exports.Colors.epbGrey,
    // === Enterprise Secondary (SC2) === //
    epSecondaryBlue: exports.Colors.epdwBlue,
    epSecondaryLightBlue: exports.Colors.epdwLightBlue,
    epSecondaryGreen: exports.Colors.epdwGreen,
    epSecondaryRed: exports.Colors.epdwRed,
    epSecondaryOrange: exports.Colors.epdwOrange,
    epSecondaryYellow: exports.Colors.epdwYellow,
    epSecondaryPurple: exports.Colors.epdwPurple,
    epSecondaryPink: exports.Colors.epdwPink,
    epSecondaryTeal: exports.Colors.epdwTeal,
    epSecondaryGrey: exports.Colors.epdwGrey,
    // === Enterprise Hover (SC3) === //
    epHoverBlue: exports.Colors.epdBlue,
    epHoverLightBlue: exports.Colors.epdLightBlue,
    epHoverGreen: exports.Colors.epdGreen,
    epHoverRed: exports.Colors.epdRed,
    epHoverOrange: exports.Colors.epdOrange,
    epHoverYellow: exports.Colors.epdYellow,
    epHoverPurple: exports.Colors.epdPurple,
    epHoverPink: exports.Colors.epdPink,
    epHoverTeal: exports.Colors.epdTeal,
    epHoverGrey: exports.Colors.epdGrey,
    // === Enterprise Highlight (SC4) === //
    epHighlightBlue: exports.Colors.epdBlue,
    epHighlightLightBlue: exports.Colors.epdLightBlue,
    epHighlightGreen: exports.Colors.epdGreen,
    epHighlightRed: exports.Colors.epdRed,
    epHighlightOrange: exports.Colors.epdOrange,
    epHighlightYellow: exports.Colors.epdYellow,
    epHighlightPurple: exports.Colors.epdPurple,
    epHighlightPink: exports.Colors.epdPink,
    epHighlightTeal: exports.Colors.epdTeal,
    epHighlightGrey: exports.Colors.epdGrey,
};
exports.LandingPageColors = {
    lpLightBlue: "#CEE8FD",
    lpLightGreen: "#BEE4BF",
    lpLightOrange: "#F6CCAC",
    lpLightOrangeTwo: "#FFD1A8",
    lpLightPink: "#FBC6C6",
    lpLightPurple: "#DDC4F7",
    lpLightYellow: "#FFE4A5",
    lpIconYellow: "#ffc94d",
    lpLightYellowTwo: "#FFE5A5",
};
exports.defaultEventColor = "#DEDEDE";
exports.solutionColors = [
    // Dark
    {
        primary: exports.SolutionColors.darkPrimaryBlue,
        hover: exports.SolutionColors.darkHoverBlue,
        highlight: exports.SolutionColors.darkHighlightBlue,
        secondary: exports.SolutionColors.darkSecondaryBlue,
    },
    {
        primary: exports.SolutionColors.darkPrimaryLightBlue,
        hover: exports.SolutionColors.darkHoverLightBlue,
        highlight: exports.SolutionColors.darkHighlightLightBlue,
        secondary: exports.SolutionColors.darkSecondaryLightBlue,
    },
    {
        primary: exports.SolutionColors.darkPrimaryGreen,
        hover: exports.SolutionColors.darkHoverGreen,
        highlight: exports.SolutionColors.darkHighlightGreen,
        secondary: exports.SolutionColors.darkSecondaryGreen,
    },
    {
        primary: exports.SolutionColors.darkPrimaryRed,
        hover: exports.SolutionColors.darkHoverRed,
        highlight: exports.SolutionColors.darkHighlightRed,
        secondary: exports.SolutionColors.darkSecondaryRed,
    },
    {
        primary: exports.SolutionColors.darkPrimaryOrange,
        hover: exports.SolutionColors.darkHoverOrange,
        highlight: exports.SolutionColors.darkHighlightOrange,
        secondary: exports.SolutionColors.darkSecondaryOrange,
    },
    {
        primary: exports.SolutionColors.darkPrimaryYellow,
        hover: exports.SolutionColors.darkHoverYellow,
        highlight: exports.SolutionColors.darkHighlightYellow,
        secondary: exports.SolutionColors.darkSecondaryYellow,
    },
    {
        primary: exports.SolutionColors.darkPrimaryPurple,
        hover: exports.SolutionColors.darkHoverPurple,
        highlight: exports.SolutionColors.darkHighlightPurple,
        secondary: exports.SolutionColors.darkSecondaryPurple,
    },
    {
        primary: exports.SolutionColors.darkPrimaryPink,
        hover: exports.SolutionColors.darkHoverPink,
        highlight: exports.SolutionColors.darkHighlightPink,
        secondary: exports.SolutionColors.darkSecondaryPink,
    },
    {
        primary: exports.SolutionColors.darkPrimaryTeal,
        hover: exports.SolutionColors.darkHoverTeal,
        highlight: exports.SolutionColors.darkHighlightTeal,
        secondary: exports.SolutionColors.darkSecondaryTeal,
    },
    {
        primary: exports.SolutionColors.darkPrimaryGrey,
        hover: exports.SolutionColors.darkHoverGrey,
        highlight: exports.SolutionColors.darkHighlightGrey,
        secondary: exports.SolutionColors.darkSecondaryGrey,
    },
    // Base
    {
        primary: exports.SolutionColors.basePrimaryBlue,
        hover: exports.SolutionColors.baseHoverBlue,
        highlight: exports.SolutionColors.baseHighlightBlue,
        secondary: exports.SolutionColors.baseSecondaryBlue,
    },
    {
        primary: exports.SolutionColors.basePrimaryLightBlue,
        hover: exports.SolutionColors.baseHoverLightBlue,
        highlight: exports.SolutionColors.baseHighlightLightBlue,
        secondary: exports.SolutionColors.baseSecondaryLightBlue,
    },
    {
        primary: exports.SolutionColors.basePrimaryGreen,
        hover: exports.SolutionColors.baseHoverGreen,
        highlight: exports.SolutionColors.baseHighlightGreen,
        secondary: exports.SolutionColors.baseSecondaryGreen,
    },
    {
        primary: exports.SolutionColors.basePrimaryRed,
        hover: exports.SolutionColors.baseHoverRed,
        highlight: exports.SolutionColors.baseHighlightRed,
        secondary: exports.SolutionColors.baseSecondaryRed,
    },
    {
        primary: exports.SolutionColors.basePrimaryOrange,
        hover: exports.SolutionColors.baseHoverOrange,
        highlight: exports.SolutionColors.baseHighlightOrange,
        secondary: exports.SolutionColors.baseSecondaryOrange,
    },
    {
        primary: exports.SolutionColors.basePrimaryYellow,
        hover: exports.SolutionColors.baseHoverYellow,
        highlight: exports.SolutionColors.baseHighlightYellow,
        secondary: exports.SolutionColors.baseSecondaryYellow,
    },
    {
        primary: exports.SolutionColors.basePrimaryPurple,
        hover: exports.SolutionColors.baseHoverPurple,
        highlight: exports.SolutionColors.baseHighlightPurple,
        secondary: exports.SolutionColors.baseSecondaryPurple,
    },
    {
        primary: exports.SolutionColors.basePrimaryPink,
        hover: exports.SolutionColors.baseHoverPink,
        highlight: exports.SolutionColors.baseHighlightPink,
        secondary: exports.SolutionColors.baseSecondaryPink,
    },
    {
        primary: exports.SolutionColors.basePrimaryTeal,
        hover: exports.SolutionColors.baseHoverTeal,
        highlight: exports.SolutionColors.baseHighlightTeal,
        secondary: exports.SolutionColors.baseSecondaryTeal,
    },
    {
        primary: exports.SolutionColors.basePrimaryGrey,
        hover: exports.SolutionColors.baseHoverGrey,
        highlight: exports.SolutionColors.baseHighlightGrey,
        secondary: exports.SolutionColors.baseSecondaryGrey,
    },
    // Enterprise
    {
        primary: exports.SolutionColors.epPrimaryBlue,
        hover: exports.SolutionColors.epHoverBlue,
        highlight: exports.SolutionColors.epHighlightBlue,
        secondary: exports.SolutionColors.epSecondaryBlue,
    },
    {
        primary: exports.SolutionColors.epPrimaryLightBlue,
        hover: exports.SolutionColors.epHoverLightBlue,
        highlight: exports.SolutionColors.epHighlightLightBlue,
        secondary: exports.SolutionColors.epSecondaryLightBlue,
    },
    {
        primary: exports.SolutionColors.epPrimaryGreen,
        hover: exports.SolutionColors.epHoverGreen,
        highlight: exports.SolutionColors.epHighlightGreen,
        secondary: exports.SolutionColors.epSecondaryGreen,
    },
    {
        primary: exports.SolutionColors.epPrimaryRed,
        hover: exports.SolutionColors.epHoverRed,
        highlight: exports.SolutionColors.epHighlightRed,
        secondary: exports.SolutionColors.epSecondaryRed,
    },
    {
        primary: exports.SolutionColors.epPrimaryOrange,
        hover: exports.SolutionColors.epHoverOrange,
        highlight: exports.SolutionColors.epHighlightOrange,
        secondary: exports.SolutionColors.epSecondaryOrange,
    },
    {
        primary: exports.SolutionColors.epPrimaryYellow,
        hover: exports.SolutionColors.epHoverYellow,
        highlight: exports.SolutionColors.epHighlightYellow,
        secondary: exports.SolutionColors.epSecondaryYellow,
    },
    {
        primary: exports.SolutionColors.epPrimaryPurple,
        hover: exports.SolutionColors.epHoverPurple,
        highlight: exports.SolutionColors.epHighlightPurple,
        secondary: exports.SolutionColors.epSecondaryPurple,
    },
    {
        primary: exports.SolutionColors.epPrimaryPink,
        hover: exports.SolutionColors.epHoverPink,
        highlight: exports.SolutionColors.epHighlightPink,
        secondary: exports.SolutionColors.epSecondaryPink,
    },
    {
        primary: exports.SolutionColors.epPrimaryTeal,
        hover: exports.SolutionColors.epHoverTeal,
        highlight: exports.SolutionColors.epHighlightTeal,
        secondary: exports.SolutionColors.epSecondaryTeal,
    },
    {
        primary: exports.SolutionColors.epPrimaryGrey,
        hover: exports.SolutionColors.epHoverGrey,
        highlight: exports.SolutionColors.epHighlightGrey,
        secondary: exports.SolutionColors.epSecondaryGrey,
    },
];
exports.defaultSolutionColor = {
    primary: exports.SolutionColors.basePrimaryBlue,
    hover: exports.SolutionColors.baseHoverBlue,
    highlight: exports.SolutionColors.baseHighlightBlue,
    secondary: exports.SolutionColors.baseSecondaryBlue,
};
exports.colorsFontsMap = [
    { background: exports.Colors.dBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.dLightBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.dGreen, font: exports.TextColorNames.white },
    { background: exports.Colors.dRed, font: exports.TextColorNames.white },
    { background: exports.Colors.dOrange, font: exports.TextColorNames.white },
    { background: exports.Colors.dYellow, font: exports.TextColorNames.white },
    { background: exports.Colors.dPurple, font: exports.TextColorNames.white },
    { background: exports.Colors.dPink, font: exports.TextColorNames.white },
    { background: exports.Colors.dGrey, font: exports.TextColorNames.white },
    { background: exports.Colors.dTeal, font: exports.TextColorNames.white },
    { background: exports.Colors.bBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.bLightBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.bGreen, font: exports.TextColorNames.white },
    { background: exports.Colors.bRed, font: exports.TextColorNames.white },
    { background: exports.Colors.bOrange, font: exports.TextColorNames.white },
    { background: exports.Colors.bYellow, font: exports.TextColorNames.white },
    { background: exports.Colors.bPurple, font: exports.TextColorNames.white },
    { background: exports.Colors.bPink, font: exports.TextColorNames.white },
    { background: exports.Colors.bTeal, font: exports.TextColorNames.white },
    { background: exports.Colors.bGrey, font: exports.TextColorNames.white },
    { background: exports.Colors.wBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.wLightBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.wGreen, font: exports.TextColorNames.primary },
    { background: exports.Colors.wRed, font: exports.TextColorNames.primary },
    { background: exports.Colors.wOrange, font: exports.TextColorNames.primary },
    { background: exports.Colors.wYellow, font: exports.TextColorNames.primary },
    { background: exports.Colors.wPurple, font: exports.TextColorNames.primary },
    { background: exports.Colors.wPink, font: exports.TextColorNames.primary },
    { background: exports.Colors.wTeal, font: exports.TextColorNames.primary },
    { background: exports.Colors.wGrey, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwLightBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwGreen, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwRed, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwOrange, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwYellow, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwPurple, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwPink, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwTeal, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwGrey, font: exports.TextColorNames.primary },
    // Enterprise
    { background: exports.Colors.epdBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.epdLightBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.epdGreen, font: exports.TextColorNames.white },
    { background: exports.Colors.epdRed, font: exports.TextColorNames.white },
    { background: exports.Colors.epdOrange, font: exports.TextColorNames.white },
    { background: exports.Colors.epdYellow, font: exports.TextColorNames.white },
    { background: exports.Colors.epdPurple, font: exports.TextColorNames.white },
    { background: exports.Colors.epdPink, font: exports.TextColorNames.white },
    { background: exports.Colors.epdTeal, font: exports.TextColorNames.white },
    { background: exports.Colors.epdGrey, font: exports.TextColorNames.white },
    { background: exports.Colors.epbBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.epbLightBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.epbGreen, font: exports.TextColorNames.white },
    { background: exports.Colors.epbRed, font: exports.TextColorNames.white },
    { background: exports.Colors.epbOrange, font: exports.TextColorNames.white },
    { background: exports.Colors.epbYellow, font: exports.TextColorNames.white },
    { background: exports.Colors.epbPurple, font: exports.TextColorNames.white },
    { background: exports.Colors.epbPink, font: exports.TextColorNames.white },
    { background: exports.Colors.epbTeal, font: exports.TextColorNames.white },
    { background: exports.Colors.epbGrey, font: exports.TextColorNames.white },
    { background: exports.Colors.epwBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwLightBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwGreen, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwRed, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwOrange, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwYellow, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwPurple, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwPink, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwTeal, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwGrey, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwLightBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwGreen, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwRed, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwOrange, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwYellow, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwPurple, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwPink, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwTeal, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwGrey, font: exports.TextColorNames.primary },
];
exports.colorsSelectFontsMap = [
    { background: exports.Colors.dBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.dLightBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.dGreen, font: exports.TextColorNames.white },
    { background: exports.Colors.dRed, font: exports.TextColorNames.white },
    { background: exports.Colors.dOrange, font: exports.TextColorNames.white },
    { background: exports.Colors.dYellow, font: exports.TextColorNames.white },
    { background: exports.Colors.dPurple, font: exports.TextColorNames.white },
    { background: exports.Colors.dPink, font: exports.TextColorNames.white },
    { background: exports.Colors.dGrey, font: exports.TextColorNames.white },
    { background: exports.Colors.dTeal, font: exports.TextColorNames.white },
    { background: exports.Colors.bBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.bLightBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.bGreen, font: exports.TextColorNames.white },
    { background: exports.Colors.bRed, font: exports.TextColorNames.white },
    { background: exports.Colors.bOrange, font: exports.TextColorNames.white },
    { background: exports.Colors.bYellow, font: exports.TextColorNames.white },
    { background: exports.Colors.bPurple, font: exports.TextColorNames.white },
    { background: exports.Colors.bPink, font: exports.TextColorNames.white },
    { background: exports.Colors.bTeal, font: exports.TextColorNames.white },
    { background: exports.Colors.bGrey, font: exports.TextColorNames.white },
    // Enterprise Base
    { background: exports.Colors.epdBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.epdLightBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.epdGreen, font: exports.TextColorNames.white },
    { background: exports.Colors.epdRed, font: exports.TextColorNames.white },
    { background: exports.Colors.epdOrange, font: exports.TextColorNames.white },
    { background: exports.Colors.epdYellow, font: exports.TextColorNames.white },
    { background: exports.Colors.epdPurple, font: exports.TextColorNames.white },
    { background: exports.Colors.epdPink, font: exports.TextColorNames.white },
    { background: exports.Colors.epdTeal, font: exports.TextColorNames.white },
    { background: exports.Colors.epdGrey, font: exports.TextColorNames.white },
    { background: exports.Colors.epbBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.epbLightBlue, font: exports.TextColorNames.white },
    { background: exports.Colors.epbGreen, font: exports.TextColorNames.white },
    { background: exports.Colors.epbRed, font: exports.TextColorNames.white },
    { background: exports.Colors.epbOrange, font: exports.TextColorNames.white },
    { background: exports.Colors.epbYellow, font: exports.TextColorNames.white },
    { background: exports.Colors.epbPurple, font: exports.TextColorNames.white },
    { background: exports.Colors.epbPink, font: exports.TextColorNames.white },
    { background: exports.Colors.epbTeal, font: exports.TextColorNames.white },
    { background: exports.Colors.epbGrey, font: exports.TextColorNames.white },
    { background: exports.Colors.wBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.wLightBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.wGreen, font: exports.TextColorNames.primary },
    { background: exports.Colors.wRed, font: exports.TextColorNames.primary },
    { background: exports.Colors.wOrange, font: exports.TextColorNames.primary },
    { background: exports.Colors.wYellow, font: exports.TextColorNames.primary },
    { background: exports.Colors.wPurple, font: exports.TextColorNames.primary },
    { background: exports.Colors.wPink, font: exports.TextColorNames.primary },
    { background: exports.Colors.wTeal, font: exports.TextColorNames.primary },
    { background: exports.Colors.wGrey, font: exports.TextColorNames.primary },
    // Enterprise Washed
    { background: exports.Colors.epwBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwLightBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwGreen, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwRed, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwOrange, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwYellow, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwPurple, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwPink, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwTeal, font: exports.TextColorNames.primary },
    { background: exports.Colors.epwGrey, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwLightBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwGreen, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwRed, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwOrange, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwYellow, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwPurple, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwPink, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwTeal, font: exports.TextColorNames.primary },
    { background: exports.Colors.dwGrey, font: exports.TextColorNames.primary },
    // Enterprise Deep Washed
    { background: exports.Colors.epdwBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwLightBlue, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwGreen, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwRed, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwOrange, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwYellow, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwPurple, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwPink, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwTeal, font: exports.TextColorNames.primary },
    { background: exports.Colors.epdwGrey, font: exports.TextColorNames.primary },
];
exports.spotLightColors = [
    exports.Colors.dBlue,
    exports.Colors.dLightBlue,
    exports.Colors.dGreen,
    exports.Colors.dRed,
    exports.Colors.dOrange,
    exports.Colors.dYellow,
    exports.Colors.dPurple,
    exports.Colors.dPink,
    exports.Colors.dTeal,
    exports.Colors.dGrey,
    exports.Colors.bBlue,
    exports.Colors.bLightBlue,
    exports.Colors.bGreen,
    exports.Colors.bRed,
    exports.Colors.bOrange,
    exports.Colors.bYellow,
    exports.Colors.bPurple,
    exports.Colors.bPink,
    exports.Colors.bTeal,
    exports.Colors.bGrey,
    exports.Colors.wBlue,
    exports.Colors.wLightBlue,
    exports.Colors.wGreen,
    exports.Colors.wRed,
    exports.Colors.wOrange,
    exports.Colors.wYellow,
    exports.Colors.wPurple,
    exports.Colors.wPink,
    exports.Colors.wTeal,
    exports.Colors.wGrey,
    exports.Colors.dwBlue,
    exports.Colors.dwLightBlue,
    exports.Colors.dwGreen,
    exports.Colors.dwRed,
    exports.Colors.dwOrange,
    exports.Colors.dwYellow,
    exports.Colors.dwPurple,
    exports.Colors.dwPink,
    exports.Colors.dwTeal,
    exports.Colors.dwGrey,
];
exports.calendarColors = [
    exports.Colors.wBlue,
    exports.Colors.wLightBlue,
    exports.Colors.wGreen,
    exports.Colors.wRed,
    exports.Colors.wOrange,
    exports.Colors.wYellow,
    exports.Colors.wPurple,
    exports.Colors.wPink,
    exports.Colors.wTeal,
    exports.Colors.wGrey,
    exports.Colors.dwBlue,
    exports.Colors.dwLightBlue,
    exports.Colors.dwGreen,
    exports.Colors.dwRed,
    exports.Colors.dwOrange,
    exports.Colors.dwYellow,
    exports.Colors.dwPurple,
    exports.Colors.dwPink,
    exports.Colors.dwTeal,
    exports.Colors.dwGrey,
    exports.Colors.dBlue,
    exports.Colors.dLightBlue,
    exports.Colors.dGreen,
    exports.Colors.dRed,
    exports.Colors.dOrange,
    exports.Colors.dYellow,
    exports.Colors.dPurple,
    exports.Colors.dPink,
    exports.Colors.dTeal,
    exports.Colors.dGrey,
    exports.Colors.bBlue,
    exports.Colors.bLightBlue,
    exports.Colors.bGreen,
    exports.Colors.bRed,
    exports.Colors.bOrange,
    exports.Colors.bYellow,
    exports.Colors.bPurple,
    exports.Colors.bPink,
    exports.Colors.bTeal,
    exports.Colors.bGrey,
];
/** Associate dark colors with a matching washed color. */
exports.matchingWashedColorMap = {
    // === Darker === //
    [exports.Colors.dBlue]: exports.Colors.wBlue,
    [exports.Colors.dLightBlue]: exports.Colors.wLightBlue,
    [exports.Colors.dGreen]: exports.Colors.wGreen,
    [exports.Colors.dRed]: exports.Colors.wRed,
    [exports.Colors.dOrange]: exports.Colors.wOrange,
    [exports.Colors.dYellow]: exports.Colors.wYellow,
    [exports.Colors.dPurple]: exports.Colors.wPurple,
    [exports.Colors.dPink]: exports.Colors.wPink,
    [exports.Colors.dTeal]: exports.Colors.wTeal,
    [exports.Colors.dGrey]: exports.Colors.wGrey,
    // === Base === //
    [exports.Colors.bBlue]: exports.Colors.wBlue,
    [exports.Colors.bLightBlue]: exports.Colors.wLightBlue,
    [exports.Colors.bGreen]: exports.Colors.wGreen,
    [exports.Colors.bRed]: exports.Colors.wRed,
    [exports.Colors.bOrange]: exports.Colors.wOrange,
    [exports.Colors.bYellow]: exports.Colors.wYellow,
    [exports.Colors.bPurple]: exports.Colors.wPurple,
    [exports.Colors.bPink]: exports.Colors.wPink,
    [exports.Colors.bTeal]: exports.Colors.wTeal,
    [exports.Colors.bGrey]: exports.Colors.wGrey,
    // Enterprise
    [exports.Colors.epdBlue]: exports.Colors.epwBlue,
    [exports.Colors.epdLightBlue]: exports.Colors.epwLightBlue,
    [exports.Colors.epdGreen]: exports.Colors.epwGreen,
    [exports.Colors.epdRed]: exports.Colors.epwRed,
    [exports.Colors.epdOrange]: exports.Colors.epwOrange,
    [exports.Colors.epdYellow]: exports.Colors.epwYellow,
    [exports.Colors.epdPurple]: exports.Colors.epwPurple,
    [exports.Colors.epdPink]: exports.Colors.epwPink,
    [exports.Colors.epdTeal]: exports.Colors.epwTeal,
    [exports.Colors.epdGrey]: exports.Colors.epwGrey,
    [exports.Colors.epbBlue]: exports.Colors.epwBlue,
    [exports.Colors.epbLightBlue]: exports.Colors.epwLightBlue,
    [exports.Colors.epbGreen]: exports.Colors.epwGreen,
    [exports.Colors.epbRed]: exports.Colors.epwRed,
    [exports.Colors.epbOrange]: exports.Colors.epwOrange,
    [exports.Colors.epbYellow]: exports.Colors.epwYellow,
    [exports.Colors.epbPurple]: exports.Colors.epwPurple,
    [exports.Colors.epbPink]: exports.Colors.epwPink,
    [exports.Colors.epbTeal]: exports.Colors.epwTeal,
    [exports.Colors.epbGrey]: exports.Colors.epwGrey,
};
/** Associate dark colors with a matching deep washed color. */
exports.matchingDeepWashedColorMap = {
    // === Darker === //
    [exports.Colors.dBlue]: exports.Colors.dwBlue,
    [exports.Colors.dLightBlue]: exports.Colors.dwLightBlue,
    [exports.Colors.dGreen]: exports.Colors.dwGreen,
    [exports.Colors.dRed]: exports.Colors.dwRed,
    [exports.Colors.dOrange]: exports.Colors.dwOrange,
    [exports.Colors.dYellow]: exports.Colors.dwYellow,
    [exports.Colors.dPurple]: exports.Colors.dwPurple,
    [exports.Colors.dPink]: exports.Colors.dwPink,
    [exports.Colors.dTeal]: exports.Colors.dwTeal,
    [exports.Colors.dGrey]: exports.Colors.dwGrey,
    // === Base === //
    [exports.Colors.bBlue]: exports.Colors.dwBlue,
    [exports.Colors.bLightBlue]: exports.Colors.dwLightBlue,
    [exports.Colors.bGreen]: exports.Colors.dwGreen,
    [exports.Colors.bRed]: exports.Colors.dwRed,
    [exports.Colors.bOrange]: exports.Colors.dwOrange,
    [exports.Colors.bYellow]: exports.Colors.dwYellow,
    [exports.Colors.bPurple]: exports.Colors.dwPurple,
    [exports.Colors.bPink]: exports.Colors.dwPink,
    [exports.Colors.bTeal]: exports.Colors.dwTeal,
    [exports.Colors.bGrey]: exports.Colors.dwGrey,
    // Enterprise
    [exports.Colors.epdBlue]: exports.Colors.epdwBlue,
    [exports.Colors.epdLightBlue]: exports.Colors.epdwLightBlue,
    [exports.Colors.epdGreen]: exports.Colors.epdwGreen,
    [exports.Colors.epdRed]: exports.Colors.epdwRed,
    [exports.Colors.epdOrange]: exports.Colors.epdwOrange,
    [exports.Colors.epdYellow]: exports.Colors.epdwYellow,
    [exports.Colors.epdPurple]: exports.Colors.epdwPurple,
    [exports.Colors.epdPink]: exports.Colors.epdwPink,
    [exports.Colors.epdTeal]: exports.Colors.epdwTeal,
    [exports.Colors.epdGrey]: exports.Colors.epdwGrey,
    [exports.Colors.epbBlue]: exports.Colors.epdwBlue,
    [exports.Colors.epbLightBlue]: exports.Colors.epdwLightBlue,
    [exports.Colors.epbGreen]: exports.Colors.epdwGreen,
    [exports.Colors.epbRed]: exports.Colors.epdwRed,
    [exports.Colors.epbOrange]: exports.Colors.epdwOrange,
    [exports.Colors.epbYellow]: exports.Colors.epdwYellow,
    [exports.Colors.epbPurple]: exports.Colors.epdwPurple,
    [exports.Colors.epbPink]: exports.Colors.epdwPink,
    [exports.Colors.epbTeal]: exports.Colors.epdwTeal,
    [exports.Colors.epbGrey]: exports.Colors.epdwGrey,
};
/** Dark colors that have a matching washed color */
exports.darkColors = Object.keys(exports.matchingWashedColorMap);
exports.matchingDarkerColorMap = {
    // === Base === //
    [exports.Colors.bBlue]: exports.Colors.dBlue,
    [exports.Colors.bLightBlue]: exports.Colors.dLightBlue,
    [exports.Colors.bGreen]: exports.Colors.dGreen,
    [exports.Colors.bRed]: exports.Colors.dRed,
    [exports.Colors.bOrange]: exports.Colors.dOrange,
    [exports.Colors.bYellow]: exports.Colors.dYellow,
    [exports.Colors.bPurple]: exports.Colors.dPurple,
    [exports.Colors.bPink]: exports.Colors.dPink,
    [exports.Colors.bTeal]: exports.Colors.dTeal,
    [exports.Colors.bGrey]: exports.Colors.dGrey,
    // === Washed === //
    [exports.Colors.wBlue]: exports.Colors.dBlue,
    [exports.Colors.wLightBlue]: exports.Colors.dLightBlue,
    [exports.Colors.wGreen]: exports.Colors.dGreen,
    [exports.Colors.wRed]: exports.Colors.dRed,
    [exports.Colors.wOrange]: exports.Colors.dOrange,
    [exports.Colors.wYellow]: exports.Colors.dYellow,
    [exports.Colors.wPurple]: exports.Colors.dPurple,
    [exports.Colors.wPink]: exports.Colors.dPink,
    [exports.Colors.wTeal]: exports.Colors.dTeal,
    [exports.Colors.wGrey]: exports.Colors.dGrey,
    // === Deep Washed === //
    [exports.Colors.dwBlue]: exports.Colors.dBlue,
    [exports.Colors.dwLightBlue]: exports.Colors.dLightBlue,
    [exports.Colors.dwGreen]: exports.Colors.dGreen,
    [exports.Colors.dwRed]: exports.Colors.dRed,
    [exports.Colors.dwOrange]: exports.Colors.dOrange,
    [exports.Colors.dwYellow]: exports.Colors.dYellow,
    [exports.Colors.dwPurple]: exports.Colors.dPurple,
    [exports.Colors.dwPink]: exports.Colors.dPink,
    [exports.Colors.dwTeal]: exports.Colors.dTeal,
    [exports.Colors.dwGrey]: exports.Colors.dGrey,
    // Enterprise
    [exports.Colors.epbBlue]: exports.Colors.epdBlue,
    [exports.Colors.epbLightBlue]: exports.Colors.epdLightBlue,
    [exports.Colors.epbGreen]: exports.Colors.epdGreen,
    [exports.Colors.epbRed]: exports.Colors.epdRed,
    [exports.Colors.epbOrange]: exports.Colors.epdOrange,
    [exports.Colors.epbYellow]: exports.Colors.epdYellow,
    [exports.Colors.epbPurple]: exports.Colors.epdPurple,
    [exports.Colors.epbPink]: exports.Colors.epdPink,
    [exports.Colors.epbTeal]: exports.Colors.epdTeal,
    [exports.Colors.epbGrey]: exports.Colors.epdGrey,
    [exports.Colors.epwBlue]: exports.Colors.epdBlue,
    [exports.Colors.epwLightBlue]: exports.Colors.epdLightBlue,
    [exports.Colors.epwGreen]: exports.Colors.epdGreen,
    [exports.Colors.epwRed]: exports.Colors.epdRed,
    [exports.Colors.epwOrange]: exports.Colors.epdOrange,
    [exports.Colors.epwYellow]: exports.Colors.epdYellow,
    [exports.Colors.epwPurple]: exports.Colors.epdPurple,
    [exports.Colors.epwPink]: exports.Colors.epdPink,
    [exports.Colors.epwTeal]: exports.Colors.epdTeal,
    [exports.Colors.epwGrey]: exports.Colors.epdGrey,
    [exports.Colors.epdwBlue]: exports.Colors.epdBlue,
    [exports.Colors.epdwLightBlue]: exports.Colors.epdLightBlue,
    [exports.Colors.epdwGreen]: exports.Colors.epdGreen,
    [exports.Colors.epdwRed]: exports.Colors.epdRed,
    [exports.Colors.epdwOrange]: exports.Colors.epdOrange,
    [exports.Colors.epdwYellow]: exports.Colors.epdYellow,
    [exports.Colors.epdwPurple]: exports.Colors.epdPurple,
    [exports.Colors.epdwPink]: exports.Colors.epdPink,
    [exports.Colors.epdwTeal]: exports.Colors.epdTeal,
    [exports.Colors.epdwGrey]: exports.Colors.epdGrey,
};
exports.matchingDWColorWithWashedColorMap = {
    // === Deep Washed === //
    [exports.Colors.dwBlue]: exports.Colors.wBlue,
    [exports.Colors.dwLightBlue]: exports.Colors.wLightBlue,
    [exports.Colors.dwGreen]: exports.Colors.wGreen,
    [exports.Colors.dwRed]: exports.Colors.wRed,
    [exports.Colors.dwOrange]: exports.Colors.wOrange,
    [exports.Colors.dwYellow]: exports.Colors.wYellow,
    [exports.Colors.dwPurple]: exports.Colors.wPurple,
    [exports.Colors.dwPink]: exports.Colors.wPink,
    [exports.Colors.dwTeal]: exports.Colors.wTeal,
    [exports.Colors.dwGrey]: exports.Colors.wGrey,
    // Enterprise
    [exports.Colors.epdwBlue]: exports.Colors.epwBlue,
    [exports.Colors.epdwLightBlue]: exports.Colors.epwLightBlue,
    [exports.Colors.epdwGreen]: exports.Colors.epwGreen,
    [exports.Colors.epdwRed]: exports.Colors.epwRed,
    [exports.Colors.epdwOrange]: exports.Colors.epwOrange,
    [exports.Colors.epdwYellow]: exports.Colors.epwYellow,
    [exports.Colors.epdwPurple]: exports.Colors.epwPurple,
    [exports.Colors.epdwPink]: exports.Colors.epwPink,
    [exports.Colors.epdwTeal]: exports.Colors.epwTeal,
    [exports.Colors.epdwGrey]: exports.Colors.epwGrey,
};
exports.matchingBaseColorMap = {
    // === Darker === //
    [exports.Colors.dBlue]: exports.Colors.bBlue,
    [exports.Colors.dLightBlue]: exports.Colors.bLightBlue,
    [exports.Colors.dGreen]: exports.Colors.bGreen,
    [exports.Colors.dRed]: exports.Colors.bRed,
    [exports.Colors.dOrange]: exports.Colors.bOrange,
    [exports.Colors.dYellow]: exports.Colors.bYellow,
    [exports.Colors.dPurple]: exports.Colors.bPurple,
    [exports.Colors.dPink]: exports.Colors.bPink,
    [exports.Colors.dTeal]: exports.Colors.bTeal,
    [exports.Colors.dGrey]: exports.Colors.bGrey,
    // === Washed === //
    [exports.Colors.wBlue]: exports.Colors.bBlue,
    [exports.Colors.wLightBlue]: exports.Colors.bLightBlue,
    [exports.Colors.wGreen]: exports.Colors.bGreen,
    [exports.Colors.wRed]: exports.Colors.bRed,
    [exports.Colors.wOrange]: exports.Colors.bOrange,
    [exports.Colors.wYellow]: exports.Colors.bYellow,
    [exports.Colors.wPurple]: exports.Colors.bPurple,
    [exports.Colors.wPink]: exports.Colors.bPink,
    [exports.Colors.wTeal]: exports.Colors.bTeal,
    [exports.Colors.wGrey]: exports.Colors.bGrey,
    // === Deep Washed === //
    [exports.Colors.dwBlue]: exports.Colors.bBlue,
    [exports.Colors.dwLightBlue]: exports.Colors.bLightBlue,
    [exports.Colors.dwGreen]: exports.Colors.bGreen,
    [exports.Colors.dwRed]: exports.Colors.bRed,
    [exports.Colors.dwOrange]: exports.Colors.bOrange,
    [exports.Colors.dwYellow]: exports.Colors.bYellow,
    [exports.Colors.dwPurple]: exports.Colors.bPurple,
    [exports.Colors.dwPink]: exports.Colors.bPink,
    [exports.Colors.dwTeal]: exports.Colors.bTeal,
    [exports.Colors.dwGrey]: exports.Colors.bGrey,
    // Enterprise Darker
    [exports.Colors.epdBlue]: exports.Colors.epbBlue,
    [exports.Colors.epdLightBlue]: exports.Colors.epbLightBlue,
    [exports.Colors.epdGreen]: exports.Colors.epbGreen,
    [exports.Colors.epdRed]: exports.Colors.epbRed,
    [exports.Colors.epdOrange]: exports.Colors.epbOrange,
    [exports.Colors.epdYellow]: exports.Colors.epbYellow,
    [exports.Colors.epdPurple]: exports.Colors.epbPurple,
    [exports.Colors.epdPink]: exports.Colors.epbPink,
    [exports.Colors.epdTeal]: exports.Colors.epbTeal,
    [exports.Colors.epdGrey]: exports.Colors.epbGrey,
    // Enterprise Washed
    [exports.Colors.epwBlue]: exports.Colors.epbBlue,
    [exports.Colors.epwLightBlue]: exports.Colors.epbLightBlue,
    [exports.Colors.epwGreen]: exports.Colors.epbGreen,
    [exports.Colors.epwRed]: exports.Colors.epbRed,
    [exports.Colors.epwOrange]: exports.Colors.epbOrange,
    [exports.Colors.epwYellow]: exports.Colors.epbYellow,
    [exports.Colors.epwPurple]: exports.Colors.epbPurple,
    [exports.Colors.epwPink]: exports.Colors.epbPink,
    [exports.Colors.epwTeal]: exports.Colors.epbTeal,
    [exports.Colors.epwGrey]: exports.Colors.epbGrey,
    // Enterprise Deep Washed
    [exports.Colors.epdwBlue]: exports.Colors.epbBlue,
    [exports.Colors.epdwLightBlue]: exports.Colors.epbLightBlue,
    [exports.Colors.epdwGreen]: exports.Colors.epbGreen,
    [exports.Colors.epdwRed]: exports.Colors.epbRed,
    [exports.Colors.epdwOrange]: exports.Colors.epbOrange,
    [exports.Colors.epdwYellow]: exports.Colors.epbYellow,
    [exports.Colors.epdwPurple]: exports.Colors.epbPurple,
    [exports.Colors.epdwPink]: exports.Colors.epbPink,
    [exports.Colors.epdwTeal]: exports.Colors.epbTeal,
    [exports.Colors.epdwGrey]: exports.Colors.epbGrey,
};
exports.widgetHighlightColorPalette = [
    exports.Colors.bBlue,
    exports.Colors.bGreen,
    exports.Colors.bOrange,
    exports.Colors.bRed,
    exports.Colors.bPurple,
    exports.Colors.bLightBlue,
    exports.Colors.bTeal,
    exports.Colors.bYellow,
    exports.Colors.bPink,
    exports.Colors.bGrey,
];
exports.colorsValues = [
    // === Darker === //
    exports.Colors.dBlue,
    exports.Colors.dLightBlue,
    exports.Colors.dGreen,
    exports.Colors.dRed,
    exports.Colors.dOrange,
    exports.Colors.dYellow,
    exports.Colors.dPurple,
    exports.Colors.dPink,
    exports.Colors.dTeal,
    exports.Colors.dGrey,
    // === Base === //
    exports.Colors.bBlue,
    exports.Colors.bLightBlue,
    exports.Colors.bGreen,
    exports.Colors.bRed,
    exports.Colors.bOrange,
    exports.Colors.bYellow,
    exports.Colors.bPurple,
    exports.Colors.bPink,
    exports.Colors.bTeal,
    exports.Colors.bGrey,
    // === Washed === //
    exports.Colors.wBlue,
    exports.Colors.wLightBlue,
    exports.Colors.wGreen,
    exports.Colors.wRed,
    exports.Colors.wOrange,
    exports.Colors.wYellow,
    exports.Colors.wPurple,
    exports.Colors.wPink,
    exports.Colors.wTeal,
    exports.Colors.wGrey,
    // === Deep Washed === //
    exports.Colors.dwBlue,
    exports.Colors.dwLightBlue,
    exports.Colors.dwGreen,
    exports.Colors.dwRed,
    exports.Colors.dwOrange,
    exports.Colors.dwYellow,
    exports.Colors.dwPurple,
    exports.Colors.dwPink,
    exports.Colors.dwTeal,
    exports.Colors.dwGrey,
    // Enterprise Darker
    exports.Colors.epdBlue,
    exports.Colors.epdLightBlue,
    exports.Colors.epdGreen,
    exports.Colors.epdRed,
    exports.Colors.epdOrange,
    exports.Colors.epdYellow,
    exports.Colors.epdPurple,
    exports.Colors.epdPink,
    exports.Colors.epdTeal,
    exports.Colors.epdGrey,
    // Enterprise Base
    exports.Colors.epbBlue,
    exports.Colors.epbLightBlue,
    exports.Colors.epbGreen,
    exports.Colors.epbRed,
    exports.Colors.epbOrange,
    exports.Colors.epbYellow,
    exports.Colors.epbPurple,
    exports.Colors.epbPink,
    exports.Colors.epbTeal,
    exports.Colors.epbGrey,
    // Enterprise Washed
    exports.Colors.epwBlue,
    exports.Colors.epwLightBlue,
    exports.Colors.epwGreen,
    exports.Colors.epwRed,
    exports.Colors.epwOrange,
    exports.Colors.epwYellow,
    exports.Colors.epwPurple,
    exports.Colors.epwPink,
    exports.Colors.epwTeal,
    exports.Colors.epwGrey,
    // Enterprise Deep Washed
    exports.Colors.epdwBlue,
    exports.Colors.epdwLightBlue,
    exports.Colors.epdwGreen,
    exports.Colors.epdwRed,
    exports.Colors.epdwOrange,
    exports.Colors.epdwYellow,
    exports.Colors.epdwPurple,
    exports.Colors.epdwPink,
    exports.Colors.epdwTeal,
    exports.Colors.epdwGrey,
    // Custom
    exports.Colors.custom1,
    exports.Colors.custom2,
    exports.Colors.custom3,
    exports.Colors.custom4,
    exports.Colors.custom5,
    exports.Colors.custom6,
    exports.Colors.custom7,
    exports.Colors.custom8,
    exports.Colors.custom9,
    exports.Colors.custom10,
    exports.Colors.custom11,
    exports.Colors.custom12,
    exports.Colors.custom13,
    exports.Colors.custom14,
    exports.Colors.custom15,
    exports.Colors.custom16,
    exports.Colors.custom17,
    exports.Colors.linkedRecordFieldColor,
    exports.Colors.linkedRecordFieldHoverColor,
    exports.Colors.bulkActionMenuCloseColor,
];
exports.SOLUTION_COLORS = "solution_colors";
